import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"

import { cn } from "@/lib/utils"

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & { as?: "div" | "hr" }
>(
  (
    { className, orientation = "horizontal", decorative, as = "div", children, asChild, ...props },
    ref
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      asChild={as === "hr" || asChild}
      decorative={decorative ?? (as !== "hr")}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-border",
        as === "hr" && "border-0",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      )}
      {...props}
    >
      {as === "hr" ? <hr /> : children}
    </SeparatorPrimitive.Root>
  )
)
Separator.displayName = "Separator"

export { Separator }
